import { Injectable } from '@angular/core';
import { UserDetail } from '../model/user-detail.model';

export enum RESOURCE {
  ONBOARDING = 'ONBOARDING',
}

@Injectable({
  providedIn: 'root',
})
export class UserModeService {
  isOnboarding(userDetails: UserDetail): boolean {
    return userDetails?.resources?.some((resource) => resource.resource_name === RESOURCE.ONBOARDING) || false;
  }

  getDefaultUserType(userDetails: UserDetail): string {
    return userDetails?.user_type || '';
  }

  getDefaultBrand(userDetails: UserDetail): string {
    return userDetails?.brand || '';
  }
}
